// NATIVE

// INSTALLED
import { Dispatch } from 'redux';
import { getDataFormInputsServiceCompany } from '../../services';
import { checkingPreload, unCheckingPreload } from '../loading';
import { setImageRedux } from './filesSlice';
import { hideIconRequestErrors, showIconRequestErrors } from '../errors';
import {
  getImageServices,
  getImageServices2,
  getMarcoServices,
  getPdfBeneficiaryServices,
  getPdfGlobalServices,
  getPdfServices,
} from '../../services/files.service';

// CUSTOM

export const getImageStore = (imgName: string, typeImage: string): any => {
  return async (dispatch: any) => {
    // await dispatch( checkingPreload() );

    const result = await getImageServices(imgName, typeImage);

    //  await dispatch( unCheckingPreload() );

    return result;
  };
};

export const getMarcoStore = (typeImage: string): any => {
  return async (dispatch: any) => {
    // await dispatch( checkingPreload() );

    const result = await getMarcoServices(typeImage);

    //  await dispatch( unCheckingPreload() );

    return result;
  };
};

export const getPdfStore = (imgName: string): any => {
  return async (dispatch: any) => {
    await dispatch(checkingPreload());

    const result = await getPdfServices(imgName);

    await dispatch(unCheckingPreload());

    return result;
  };
};

export const getPdfGlobalStore = (typeUrl: string, imgName: string): any => {
  return async (dispatch: any) => {
    await dispatch(checkingPreload());

    //  const result = await getPdfServices(imgName);
    const result = await getPdfGlobalServices(typeUrl, imgName);

    await dispatch(unCheckingPreload());

    return result;
  };
};

export const getPdfBeneficiaryStore = (imgName: string): any => {
  return async (dispatch: any) => {
    await dispatch(checkingPreload());

    const result = await getPdfBeneficiaryServices(imgName);

    await dispatch(unCheckingPreload());

    return result;
  };
};

export const getImageStore2 = (imgName: string): any => {
  return async (dispatch: any) => {
    await dispatch(checkingPreload());

    const result = await getImageServices2(imgName);

    await dispatch(unCheckingPreload());

    return result;
  };
};
